import config from '../../../share/config';

// キーコード
const CTRL = 17;
const ALT = 18;
const KEY_U = 85;

// キー名を定義
const KEY_DIAG = 'diag_code';
const KEY_CANCEL_CODE = 'cancel_code';
const KEY_DATA_MONITOR = 'data_monitor';

// ユニークキー定義
const UNIQUE_KEY_U = 'U';

// 特殊キー入力で表示する機能
export const SP_KEY_INFO = [
  {
    type: config.SPECIAL_FEATURE_DIAG_CODE,
    key: KEY_DIAG,
    code: [CTRL, ALT, KEY_U],
    uniqueKey: UNIQUE_KEY_U
  },
  {
    type: config.SPECIAL_FEATURE_CANCEL_CODE,
    key: KEY_CANCEL_CODE,
    code: [CTRL, ALT, KEY_U],
    uniqueKey: UNIQUE_KEY_U
  },
  {
    type: config.SPECIAL_FEATURE_DATA_MONITOR,
    key: KEY_DATA_MONITOR,
    code: [CTRL, ALT, KEY_U],
    uniqueKey: UNIQUE_KEY_U
  }
];

// 各ECUが特殊キー入力によりどの機能を表示できるか
export const SUPPORTED_FEATURES = [
  { ES: [config.SPECIAL_FEATURE_DIAG_CODE, config.SPECIAL_FEATURE_CANCEL_CODE, config.SPECIAL_FEATURE_DATA_MONITOR] },
  { ADAS: [config.SPECIAL_FEATURE_DIAG_CODE, config.SPECIAL_FEATURE_DATA_MONITOR] }
];

// 各フェーズ定義
export const PHASE = {
  INPUT_PASSWORD: 'inputPassword',
  INPUT_ERROR: 'inputError'
};
